import { Injectable } from '@angular/core';
import { Observable, EMPTY } from 'rxjs';

import { MeteringApiService } from '@shure/shared/angular/data-access/device-metering';
import { AutomixGainMetering, StereoAutomixGainMetering } from '@shure/shared/angular/data-access/system-api/models';
import {
	AudioMetering,
	ChannelMetering,
	StereoChannelMetering,
	BoostCutMetering,
	CompressorEngaged,
	LimiterEngaged,
	AudioGateOnMetering,
	AecErleMetering,
	DenoiserNoiseReduction,
	RfChannelMetering,
	MultiAntennaRfChannelMetering,
	ChannelAnalogStereoMetering
} from '@shure/shared/models';

@Injectable()
export class CdmMeteringApiService extends MeteringApiService {
	public getAudioMetering$(_coverageAreaId: string): Observable<AudioMetering> {
		return EMPTY;
	}

	public getVirtualAudioMetering$(_coverageAreaId: string): Observable<AudioMetering> {
		return EMPTY;
	}

	public isChannelGatedOn$(_channelId: string, _isVirtual: boolean): Observable<boolean> {
		return EMPTY;
	}

	public isCoverageAreaGatedOn$(_coverageAreaId: string, _isVirtual: boolean): Observable<boolean> {
		return EMPTY;
	}

	public subscribeChannelMetering$(_channelId: string, _isVirtual: boolean): Observable<ChannelMetering> {
		return EMPTY;
	}

	public subscribeChannelAnalogStereoMetering$(
		_channelId: string,
		_isVirtual: boolean
	): Observable<ChannelAnalogStereoMetering> {
		return EMPTY;
	}

	public subscribeMatrixMixerOutputMetering$(_channelId: string, _isVirtual: boolean): Observable<ChannelMetering> {
		return EMPTY;
	}

	public subscribeMatrixMixerInputMetering$(_channelId: string, _isVirtual: boolean): Observable<ChannelMetering> {
		return EMPTY;
	}

	public subscribeGenericMatrixMixerMetering$(_channelId: string, _isVirtual: boolean): Observable<ChannelMetering> {
		return EMPTY;
	}

	public subscribeStereoChannelMetering$(_channelId: string, _isVirtual: boolean): Observable<StereoChannelMetering> {
		return EMPTY;
	}

	public subscribeMatrixMixerStereoInputMetering$(
		_channelId: string,
		_isVirtual: boolean
	): Observable<StereoChannelMetering> {
		return EMPTY;
	}

	public override subscribeBondedUsbChannelMetering$(
		_leftChannelId: string,
		_rightChannelId: string,
		_isVirtual: boolean
	): Observable<StereoChannelMetering> {
		return EMPTY;
	}

	public subscribeBoostCutMetering$(_channelId: string, _isVirtual: boolean): Observable<BoostCutMetering> {
		return EMPTY;
	}

	public subscribeCompressorEngaged$(_channelId: string): Observable<CompressorEngaged> {
		return EMPTY;
	}

	public subscribeLimiterEngaged$(_channelId: string): Observable<LimiterEngaged> {
		return EMPTY;
	}

	public subscribeAudioGateOnMetering$(
		_channelId: string,
		_isVirtual: boolean,
		_updateRate?: number
	): Observable<AudioGateOnMetering> {
		return EMPTY;
	}

	public subscribeCoverageAreaGateOnMetering$(
		_coverageAreaId: string,
		_isVirtual: boolean,
		_updateRate?: number
	): Observable<AudioGateOnMetering> {
		return EMPTY;
	}

	public subscribeAutomixGainMetering$(_channelId: string, _isVirtual: boolean): Observable<AutomixGainMetering> {
		return EMPTY;
	}

	public subscribeStereoAutomixGainMetering$(
		_channelId: string,
		_isVirtual: boolean
	): Observable<StereoAutomixGainMetering> {
		return EMPTY;
	}

	public subscribePostGateGainStereoMetering$(
		_channelId: string,
		_isVirtual: boolean
	): Observable<StereoChannelMetering> {
		return EMPTY;
	}

	public subscribeAgcMetering$(_channelId: string, _isVirtual: boolean): Observable<ChannelMetering> {
		return EMPTY;
	}

	public subscribeAecErleMetering$(_channelId: string, _isVirtual: boolean): Observable<AecErleMetering> {
		return EMPTY;
	}

	public subscribeAecPostMetering$(_channelId: string, _isVirtual: boolean): Observable<ChannelMetering> {
		return EMPTY;
	}

	public subscribeAutomixerInputMetering$(_channelId: string, _isVirtual: boolean): Observable<ChannelMetering> {
		return EMPTY;
	}

	public subscribeDenoiserNRMetering$(_channelId: string, _isVirtual: boolean): Observable<DenoiserNoiseReduction> {
		return EMPTY;
	}

	public subscribeRfChannelMetering$(_channelId: string, _isVirtual: boolean): Observable<RfChannelMetering> {
		return EMPTY;
	}

	public subscribeMultiAntennaRfChannelMetering$(
		_channelId: string,
		_isVirtual: boolean
	): Observable<MultiAntennaRfChannelMetering> {
		return EMPTY;
	}

	public subscribeCompressorMetering$(_channelId: string, _isVirtual: boolean): Observable<ChannelMetering> {
		return EMPTY;
	}

	public subscribeBondedCompressorMetering$(
		_leftChannelId: string,
		_rightChannelId: string,
		_isVirtual: boolean
	): Observable<StereoChannelMetering> {
		return EMPTY;
	}
}
